__turbopack_context__.v({
  "text": "AllowMessage-module__kkaXeG__text",
});
